var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0H46C47.1046 0 48 0.895431 48 2V22C48 23.1046 47.1046 24 46 24H2C0.895431 24 0 23.1046 0 22V2Z",
    fill: "#FBFAF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 24C24 24 32.8773 22.3605 38.6591 19.9184C44.4168 17.6964 48 15 48 15V24H24Z",
    fill: "#F16822"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5519 9.13739H40.5429C41.1783 9.13739 42.4429 9.46132 42.4429 10.8175C42.4429 12.1752 41.1356 12.4561 41.1356 12.4561L43 14.8414H41.5177L39.8698 12.5649H39.7435V14.8414H38.5519V9.13739ZM39.7432 10.0884V11.7531H40.3991C40.9041 11.7531 41.2229 11.3278 41.2229 10.9559V10.8846C41.2229 10.5134 40.9041 10.0884 40.3991 10.0884H39.7432Z",
    fill: "#2A2D2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0316 9.13739H29.345L31.0262 12.8741L32.6108 9.13739H33.9246L31.3563 14.9863H30.5999L28.0316 9.13739Z",
    fill: "#2A2D2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4806 14.8414H11.7007V9.13739H10.4806V14.8414Z",
    fill: "#2A2D2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9.13727H6.99741C8.19654 9.13727 9.9557 10.1549 9.9557 11.9634V11.9844V12.0057C9.9557 13.8146 8.19654 14.8315 6.99741 14.8315H5V9.13727ZM6.15015 13.8825C6.15015 13.8825 8.71397 14.1522 8.71397 12.033V11.9998C8.71397 9.88027 6.15015 10.1503 6.15015 10.1503V13.8825Z",
    fill: "#2A2D2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6662 11.3854V12.3915H35.5913V13.8351H37.7621V14.8412H34.3794V9.13715H37.7621V10.1432H35.5913V11.3854H37.6662Z",
    fill: "#2A2D2E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.246 12.0175C28.246 13.6508 26.8274 14.9745 25.0787 14.9745C23.3293 14.9745 21.911 13.6508 21.911 12.0175C21.911 10.3839 23.3293 9.05988 25.0787 9.05988C26.8274 9.05988 28.246 10.3839 28.246 12.0175Z",
    fill: "#F16822"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.441 10.4526C15.441 10.4526 15.0391 10.0205 14.4993 10.0205C13.9606 10.0205 13.6493 10.3557 13.6493 10.5998C13.6493 10.8433 13.6392 10.9811 14.409 11.2809C15.1796 11.5818 16.312 11.7976 16.312 13.0681C16.312 14.3376 15.2466 14.9819 14.2887 14.9819C12.7776 14.9819 12.098 13.9 12.098 13.9L12.8585 13.1895C12.8585 13.1895 13.3406 13.9468 14.1816 13.9468C15.0222 13.9468 15.069 13.349 15.069 13.1524C15.069 12.8614 14.8881 12.5735 14.3689 12.3958C13.8497 12.217 12.4299 12.0379 12.4299 10.7593C12.4299 9.61126 13.3488 9.04211 14.379 9.04211C15.2998 9.04211 16.1007 9.71516 16.1007 9.71516L15.441 10.4526Z",
    fill: "#2A2D2E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3818 10.6896C21.0042 10.3251 20.4842 10.0603 19.8991 10.0603C18.752 10.0603 17.8222 10.9292 17.8222 11.9997C17.8222 13.0711 18.752 13.939 19.8991 13.939C20.4786 13.939 21.006 13.677 21.3821 13.3191L21.3818 14.6617C20.9375 14.879 20.4344 15 19.8991 15C18.1245 15 16.686 13.6571 16.686 11.9997C16.686 10.3429 18.1245 9 19.8991 9C20.4359 9 20.9371 9.12278 21.3818 9.34072V10.6896Z",
    fill: "#2A2D2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.8f9a2904035196f92c456ff2b7c41425.svg";
export { ForwardRef as ReactComponent };